let usedTileNews = [];
// let usedTileWorkhelper = [];

export default class NewsList {

    constructor(newsList) {
        this.fetchDomElements(newsList);
        this.registerMoreEventListeners();
        this.getTileNews();
        this.moreNewsLoading = 0;
        this.moreWorkhelperLoading = 0;
        this.targetTabHandler();
        if (this.domElements.navTabs) {
            this.domElements.tabLink.forEach((item) => this.registerTabEventListeners(item));
        }
        if (this.domElements.loadMoreNewsButton) {
            this.getNextNewsToShowCount();
        }
        if (this.domElements.loadMoreWorkhelperButton) {
            // this.preLoadWorkhelper();
            this.getNextWorkhelperToShowCount();
        }
    }

    fetchDomElements(newsList) {
        this.domElements = {
            newsList: newsList,
            workhelperList: newsList,
            loadMoreNewsButtonsContainer: newsList.querySelectorAll('.loadMoreNewsButtonsContainer')[0],
            loadMoreWorkhelperButtonsContainer: newsList.querySelectorAll('.loadMoreWorkhelperButtonsContainer')[0],
            loadMoreNewsButton: newsList.querySelectorAll('.loadMoreNewsButton')[0],
            loadAllNewsButton: newsList.querySelectorAll('.loadAllNewsButton')[0],
            loadMoreWorkhelperButton: newsList.querySelectorAll('.loadMoreWorkhelperButton')[0],
            loadAllWorkhelperButton: newsList.querySelectorAll('.loadAllWorkhelperButton')[0],
            newsTilesContainer: newsList.querySelectorAll('.newsTilesContainer')[0],
            workhelperTilesContainer: newsList.querySelectorAll('.workhelperTilesContainer')[0],
            category: newsList.parentElement.id,
            buttonText: "",
            workhelperButtonText: "",
            navTabs: document.querySelectorAll('.nav.nav-tabs li a'),
            tabLink: document.querySelectorAll('.tab-link'),
        };

        let newsTilesId = this.domElements.newsList.getAttribute('data-news-tiles-id');
        if (newsTilesId && !this.domElements.newsTilesContainer) {
            this.domElements.newsTilesContainer = document.getElementById(newsTilesId);
        }
    }

    registerMoreEventListeners() {
        if (this.domElements.loadMoreNewsButton) {
            this.domElements.buttonText = this.domElements.loadMoreNewsButton.firstChild.textContent;
            this.domElements.loadMoreNewsButton.addEventListener('click', () => this.onLoadMoreNewsButtonClick(false));

            window.addEventListener('resize', () => this.getNextNewsToShowCount(), {passive: true});
        }

        if (this.domElements.loadAllNewsButton) {
            this.domElements.loadAllNewsButton.addEventListener('click', () => this.onLoadMoreNewsButtonClick(true));
        }

        if (this.domElements.loadMoreWorkhelperButton) {
            this.domElements.workhelperButtonText = this.domElements.loadMoreWorkhelperButton.firstChild.textContent;
            this.domElements.loadMoreWorkhelperButton.addEventListener('click', () => this.onLoadMoreWorkhelperButtonClick(false));

            window.addEventListener('resize', () => this.getNextWorkhelperToShowCount(), {passive: true});
        }

        if (this.domElements.loadAllWorkhelperButton) {
            this.domElements.loadAllWorkhelperButton.addEventListener('click', () => this.onLoadMoreWorkhelperButtonClick(true));
        }
    }

    registerTabEventListeners(item) {
        if (item.href.split('#tab')[1] == this.domElements.category) {
            item.addEventListener('click', (e) => this.tabClickHandler(e));
        }
    }

    tabClickHandler(e) {
        this.targetTabHandler();
    }

    targetTabHandler() {
        setTimeout(() => {
            if (window.location.href.split('#tab')[1] == this.domElements.category) {
                const target = this.domElements.category;
                if (target) {
                    const items = document.getElementsByClassName('newsTilesContainer');
                    let trigger = document.querySelectorAll('.nav.nav-tabs li a[href="#'+ target +'"]')[0];
                    let con;
                    let cons = document.querySelectorAll('.newsTilesContainer');

                    cons.forEach((el) => {
                        if (window.getComputedStyle(el.parentElement).getPropertyValue('display') !== 'none') {
                            con = el;
                        }
                    });

                    if (items.length > 0 && con) {
                        let offset = -240;//-120;
                        let topValue = window.scrollY + con.getBoundingClientRect().top + offset;
                        setTimeout(function() {
                            window.scrollTo({
                                top: topValue,
                                behavior: 'smooth',
                            });

                            trigger.click();

                            window.history.pushState({}, '', window.location.href.split('#tab')[0]);
                            return false;
                        }, 10);
                    } else { // if no Tiles
                        let panes = document.querySelectorAll('.tab-pane');
                        panes.forEach((el) => {
                            if (window.getComputedStyle(el).getPropertyValue('display') !== 'none') {
                                con = el;
                            }
                        });

                        let offset = -240;//-120;
                        let topValue = window.scrollY + con.getBoundingClientRect().top + offset;
                        setTimeout(function() {
                            window.scrollTo({
                                top: topValue,
                                behavior: 'smooth',
                            });

                            trigger.click();

                            window.history.pushState({}, '', window.location.href.split('#tab')[0]);
                            return false;
                        }, 10);
                    }
                }
            }
        }, 10);
    }

    onLoadMoreNewsButtonClick(showAllNews) {
        let numberOfAdditionalNewsShown = 0;
        const totalNewsloaded = this.domElements.newsList.querySelectorAll('.articleItem').length;
        const totalAvailableNews = parseInt(this.domElements.newsList.getAttribute('data-news-total-count'));
        const startingpoint = this.domElements.newsList.getAttribute('data-startingpoint');
        const sorting = this.domElements.newsList.getAttribute('data-sorting');
        let additionalNewsToShow;

        if (window.innerWidth > 992) {
            additionalNewsToShow = 5;
        } else {
            additionalNewsToShow = 3;
        }

        if (!showAllNews) {
            this.domElements.newsList
                .querySelectorAll('.hidden')
                .forEach((el) => {
                    numberOfAdditionalNewsShown++;
                    if (numberOfAdditionalNewsShown <= additionalNewsToShow) {
                        el.classList.remove('hidden');
                    }
                });
            ;
            numberOfAdditionalNewsShown = 0;
        }

        if (showAllNews && totalNewsloaded >= totalAvailableNews) {
            $(this.domElements.newsList).find('.hidden').removeClass('hidden');
            this.domElements.loadMoreNewsButtonsContainer.style.display = 'none';
            return;
        }

        let additionalUrlParams = '?type=1638445333&hideIdList=',
            lang = document.documentElement.lang,
            cmsUrl;

        cmsUrl = window.location.href;

        if (window.location.search) {
            cmsUrl = cmsUrl.replace(window.location.search, ''); // Remove get parameter
            cmsUrl = cmsUrl.replace('index.php', '');
        }
        if (window.location.hash) {
            cmsUrl = cmsUrl.replace(window.location.hash, '');
        }

        if (lang == 'de') {
            cmsUrl = cmsUrl.replace(/www.weka\.ch\/(themen|de)?/, 'cms.weka.ch/de');
        } else {
            cmsUrl = cmsUrl.replace(/www.weka\.ch\/(themes|fr)?/, 'cms.weka.ch/fr');
        }

        let targetUrl = cmsUrl + additionalUrlParams + usedTileNews.join(',') + '&offset=' + totalNewsloaded,
            newsList = this.domElements.newsList,
            that = this,
            currentlyAvailableNews,
            nextNewsToShow;

        if (showAllNews) {
            targetUrl += '&showAll=1';
        }

        targetUrl += '&no_cache=1';

        if (startingpoint) {
            targetUrl += '&startingpoint=' + startingpoint;
        }

        if (sorting) {
            targetUrl += '&sorting=' + sorting;
        }

        if (totalAvailableNews > totalNewsloaded) {
            let $temp = $('<div />');
            that.moreNewsLoading = 1;
            if (showAllNews) {
                $('body').append('<div class="loader" />');
            }
            $temp.load(targetUrl + ' .news-list-view .newsListContainer'  + ' > *', function() {
                $(newsList).find('.newsListContainer').append($temp.children());
                if (showAllNews) {
                    $(newsList).find('.hidden').removeClass('hidden');
                }
                // currentlyAvailableNews = that.domElements.newsList.querySelectorAll('.hidden').length;
                // if (currentlyAvailableNews > additionalNewsToShow) {
                //     nextNewsToShow = additionalNewsToShow;
                // } else {
                //     nextNewsToShow = currentlyAvailableNews;
                // }
                // that.domElements.loadMoreNewsButton.firstChild.textContent = nextNewsToShow + " " + that.domElements.buttonText;
                that.getNextNewsToShowCount();
                that.moreNewsLoading = 0;

                if (showAllNews) {
                    $('body').find('.loader').remove();
                    that.domElements.loadMoreNewsButtonsContainer.style.display = 'none';
                }
            });
        } else {
            this.getNextNewsToShowCount();
        }
        if (this.moreNewsLoading == 0 && this.domElements.newsList.querySelectorAll('.hidden').length == 0) {
            this.domElements.loadMoreNewsButtonsContainer.style.display = 'none';
        }
    }

    onLoadMoreWorkhelperButtonClick(showAllWorkhelper) {
        let numberOfAdditionalWorkhelperShown = 0;
        let totalWorkhelperloaded = this.domElements.workhelperList.querySelectorAll('.articleItem').length;
        let totalAvailableWorkhelper = parseInt(this.domElements.workhelperList.getAttribute('data-workhelper-total-count'));
        let categoryID = this.domElements.workhelperList.getAttribute('data-category');
        let additionalWorkhelperToShow;

        if (window.innerWidth > 992) {
            additionalWorkhelperToShow = 5;
        } else {
            additionalWorkhelperToShow = 3;
        }

        if (!showAllWorkhelper) {
            this.domElements.workhelperList
                .querySelectorAll('.hidden')
                .forEach((el) => {
                    numberOfAdditionalWorkhelperShown++;
                    if (numberOfAdditionalWorkhelperShown <= additionalWorkhelperToShow) {
                        el.classList.remove('hidden');
                    }
                });
            ;
            numberOfAdditionalWorkhelperShown = 0;
        }

        if (showAllWorkhelper && totalWorkhelperloaded >= totalAvailableWorkhelper) {
            $(this.domElements.workhelperList).find('.hidden').removeClass('hidden');
            this.domElements.loadMoreWorkhelperButtonsContainer.style.display = 'none';
            return;
        }

        let additionalUrlParams = '?cl=wes_weka_article_tools_list_more&cnid=',
            lang = document.documentElement.lang,
            cmsUrl = window.location.href;

        // if (lang == 'de') {
        //     cmsUrl = window.location.href.replace('weka.ch/themen', 'cms.weka.ch/de');
        // } else {
        //     cmsUrl = window.location.href.replace('weka.ch/themes', 'cms.weka.ch/fr');
        // }

        if (window.location.search) {
            cmsUrl = cmsUrl.replace(window.location.search, ''); // Remove get parameter
            cmsUrl = cmsUrl.replace('index.php', '');
        }
        if (window.location.hash) {
            cmsUrl = cmsUrl.replace(window.location.hash, '');
        }

        let targetUrl = cmsUrl + additionalUrlParams + categoryID + '&offset=' + totalWorkhelperloaded,
            workhelperList = this.domElements.workhelperList,
            that = this,
            currentlyAvailableWorkhelper,
            nextWorkhelperToShow;

        if (showAllWorkhelper) {
            targetUrl += '&limit=99999';
        } else {
            targetUrl += '&limit=5';
        }

        if (totalAvailableWorkhelper > totalWorkhelperloaded) {
            let $temp = $('<div />');
            that.moreWorkhelperLoading = 1;
            if (showAllWorkhelper) {
                $('body').append('<div class="loader" />');
            }
            $temp.load(targetUrl + ' .workhelper-list-view .workhelperListContainer'  + ' > *', function() {
                $(workhelperList).find('.workhelperListContainer').append($temp.children());
                if (showAllWorkhelper) {
                    $(workhelperList).find('.hidden').removeClass('hidden');
                }
                that.getNextWorkhelperToShowCount();
                that.moreWorkhelperLoading = 0;

                if (showAllWorkhelper) {
                    $('body').find('.loader').remove();
                    that.domElements.loadMoreWorkhelperButtonsContainer.style.display = 'none';
                }
            });
        } else {
            this.getNextWorkhelperToShowCount();
        }

        if (this.moreWorkhelperLoading == 0 && this.domElements.workhelperList.querySelectorAll('.hidden').length == 0) {
            that.domElements.loadMoreWorkhelperButtonsContainer.style.display = 'none';
        }
    }

    // preLoadWorkhelper() {
    //     let $temp = $('<div />');
    //     let that = this;
    //     let workhelperList = this.domElements.workhelperList;
    //     let targetUrl = "https://relaunch.weka.ch/index.php?cl=wes_weka_article_tools_list_more&cnid=58b3d75d6557e60e86fd068b296301b0&offset=3&limit=5";
    //     $temp.load(targetUrl + ' .workhelper-list-view .workhelperListContainer'  + ' > *', function() {
    //         that.moreWorkhelperLoading = 1;
    //         $(workhelperList).find('.workhelperListContainer').append($temp.children());
    //         that.getNextWorkhelperToShowCount();
    //         that.moreWorkhelperLoading = 0;
    //     });
    // }

    getNextNewsToShowCount() {
        let additionalNewsToShow,
            nextNewsToShow;

        if (window.innerWidth > 992) {
            additionalNewsToShow = 5;
        } else {
            additionalNewsToShow = 3;
        }

        let currentlyAvailableNews = this.domElements.newsList.querySelectorAll('.hidden').length;
        if (currentlyAvailableNews > additionalNewsToShow) {
            nextNewsToShow = additionalNewsToShow;
        } else {
            nextNewsToShow = currentlyAvailableNews;
        }

        if (document.documentElement.lang == 'de') {
            this.domElements.loadMoreNewsButton.firstChild.textContent = nextNewsToShow + " " + this.domElements.buttonText;
        } else {
            this.domElements.loadMoreNewsButton.firstChild.textContent = this.domElements.buttonText + " " + nextNewsToShow;
        }
    }

    getNextWorkhelperToShowCount() {
        let additionalWorkhelperToShow,
            nextWorkhelperToShow;

        if (window.innerWidth > 992) {
            additionalWorkhelperToShow = 5;
        } else {
            additionalWorkhelperToShow = 3;
        }

        let currentlyAvailableWorkhelper = this.domElements.workhelperList.querySelectorAll('.hidden').length;
        if (currentlyAvailableWorkhelper > additionalWorkhelperToShow) {
            nextWorkhelperToShow = additionalWorkhelperToShow;
        } else {
            nextWorkhelperToShow = currentlyAvailableWorkhelper;
        }

        if (document.documentElement.lang == 'de') {
            this.domElements.loadMoreWorkhelperButton.firstChild.textContent = nextWorkhelperToShow + " " + this.domElements.workhelperButtonText;
        } else {
            this.domElements.loadMoreWorkhelperButton.firstChild.textContent = this.domElements.workhelperButtonText + " " + nextWorkhelperToShow;
        }
    }

    getTileNews() {
        if (this.domElements.newsTilesContainer) {
            this.domElements.newsTilesContainer
                .querySelectorAll('[data-uid]')
                .forEach((el) => {
                    usedTileNews.push(el.getAttribute('data-uid'));
                })
            ;
        }
    }
}
